import React from "react";
import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import ServicesVideo from "./ServicesVideo";
import DenefitsButton from "./DenefitsButton";
import { hero, successStats } from "../../mock";

export default function Hero({ onBook }) {
  return (
    <section id="home" className="relative bg-navy pt-28 sm:pt-36 pb-16 sm:pb-20 overflow-hidden">
      {/* decorative */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-navy-light/40 to-transparent pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-10 lg:gap-12 items-center relative">
        <div>
          <div className="inline-flex items-center gap-2 bg-navy-light text-gold-light px-4 py-1.5 rounded-full text-sm font-medium mb-6">
            <Sparkles className="h-4 w-4" /> Faith-Based Financial Coaching
          </div>
          <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
            {hero.kicker}
            <span className="block text-gold">{hero.title}</span>
          </h1>
          <p className="mt-6 text-gray-300 text-lg leading-relaxed max-w-xl">
            {hero.subtitle}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Button
              onClick={onBook}
              className="bg-gold hover:bg-gold-dark text-navy font-semibold h-12 px-7 text-base"
            >
              {hero.ctaPrimary} <ArrowRight className="h-5 w-5 ml-1.5" />
            </Button>
            <Button
              variant="outline"
              onClick={() => document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" })}
              className="border-gray-500 text-white hover:bg-white hover:text-navy h-12 px-7 text-base bg-transparent"
            >
              {hero.ctaSecondary}
            </Button>
            <DenefitsButton primary testId="denefits-preapproval-btn-hero" className="bg-transparent border border-gold text-gold hover:bg-gold hover:text-navy" />
          </div>
          <div className="mt-8 flex items-center gap-2 text-gray-400 text-sm">
            <ShieldCheck className="h-5 w-5 text-gold" /> Trusted by individuals, families &amp; small businesses
          </div>
        </div>

        <div className="relative">
          <ServicesVideo />
          <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4 w-40 hidden sm:block z-10">
            <div className="font-serif text-3xl font-bold text-navy">96%</div>
            <div className="text-sm text-gray-600 mt-1">
              of clients improve in weeks
            </div>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-16 relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-navy-light rounded-xl overflow-hidden border border-navy-light">
          {successStats.map((s, i) => (
            <div key={i} className="bg-navy px-6 py-6 text-center">
              <div className="font-serif text-3xl font-bold text-gold">{s.value}</div>
              <div className="text-gray-400 text-sm mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
